export const setMyself = (newUser) => {
  localStorage.setItem('user', JSON.stringify(newUser));
};

export const getMyself = () => {
  return JSON.parse(localStorage.getItem('user'));
};